<template>
  <div class="callback-container">
    <div class="loader"></div>
    <p>Signing you in...</p>
  </div>
</template>

<script>
// The Auth0 SDK handles the callback automatically (internal to auth0-vue).
// This component just displays a loading state while the SDK processes the callback.
// Once complete, the SDK navigates to appState?.target || "/" on its own.
export default {
  name: "CallbackView",
};
</script>

<style lang="scss" scoped>
.callback-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: $gray1200;
  color: $white;
}

.loader {
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  border-top: 4px solid $primary;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
